// import React, { useState } from "react";

// import CalendarEvent from "../components/CalendarEvent";
import ButtonMenu from "../components/ButtonMenu";
import ContainerBox from "../components/common/ContainerBox";
import { IconChart, IconDocument } from "../components/icons/Icons";
// import TitleBox from "../components/common/TitleBox";
// import { Counter } from "../components/Counter";
// import { CounterStats } from "../components/CounterStats";
// import { IconPlus } from "../components/icons/Icons";

const HomePage = () => {
  // const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="w-full">
        <ContainerBox>
          <div className="grid grid-cols-4 gap-10">
            <ButtonMenu title="Dashboard" icon={<IconChart className="w-20" />} url="/dashboard" />
            <ButtonMenu title="Expediente digital" icon={<IconDocument className="w-20" />} url="/expediente" />
          </div>
        </ContainerBox>
        {/* TODO: CODIGO A FUTURO PARA PAGINA HOME */}
        {/* <div className="col-span-9">
          <TitleBox title="Audiencias Programadas">
            <button
              className="max-w-fit bg-primary hover:bg-primary/90 border border-primary text-white px-3 py-1 rounded-sm flex items-center gap-1 font-light"
              onClick={() => {
                setIsOpen(true);
              }}
            >
              <IconPlus className="w-4" />
              Nuevo
            </button>
          </TitleBox>
          <ContainerBox>
            <CalendarEvent
              openModal={() => setIsOpen(true)}
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
            />
          </ContainerBox>
        </div> */}
        {/* <div className="col-span-3">
          <Counter />
        </div> */}
      </div>
      {/* <CounterStats /> */}
    </>
  );
};

export default HomePage;
